import React from "react";
import styles from './styles.module.scss';
import Try, {TryBtn} from "../../components/Try";
import TickSvg from "../../components/svg/TickSvg";
import ArrowSvg from "../../components/svg/GotoArrow";

export default function Productions() {
  return <>
    <section className={styles.head}>
      <div className={styles.headContent}>
        <div className={styles.title}>
          <h4>烯牛数据·产品</h4>
          <h1>AI原生打造， <br />新一代科创数据引擎</h1>
          <Try />
        </div>
        <div className={styles.sticker} style={{marginLeft: "164px"}}><img src="./static-official/images/sticker-production.png" height={503} alt="科创企业智能分析平台" /></div>
      </div>
    </section>
    <Platform />
    <MobileApplication />
    <Tool />
  </>
}

function Platform() {
  return <section className={styles.commonSection0}>
    <div className={styles.detailContainer}>
      <div className={styles.detailBlock} style={{width: "385px"}}>
        <h3>01 科创金融数据平台</h3>
        <desc>对科创企业及一级市场股权投资数据进行全脉络梳理，帮助用户分析前沿行业、挖掘优质科创企业、还原一级市场股权投资链条，适用于拓客、行业研究、招商引资、风险监控等多种领域。</desc>
        <ul>
          <li><h4><TickSvg />科创企业库</h4></li>
          <li><h4><TickSvg />战略新兴产业链</h4></li>
          <li><h4><TickSvg />政府引导基金库、创投机构库</h4></li>
          <li><h4><TickSvg />全球一级市场投融资数据库</h4></li>
          <li><h4><TickSvg />募资与退出线索库</h4></li>
        </ul>
        <TryBtn />
      </div>
      <img src="./static-official/images/p-1.png" alt="01 科创金融数据平台" height={495}/>
    </div>
  </section>
}

function MobileApplication() {
  return <section className={styles.commonSectionB}>
    <div className={styles.detailContainer}>
      <img src="./static-official/images/p-2.png" alt="02 烯牛数据APP" height={617} style={{marginBottom: "-12px"}}/>
      <div className={styles.detailBlock} style={{width: "500px"}}>
        <h3>02 烯牛数据APP</h3>
        <desc>科创领域AI社交与数据平台，包含科创数据查询、科创大模型AI问答、科创企业与机构动态实时追踪等功能，同时提供20万人在线的创投人脉社群与科创从业者交流平台。</desc>
        <ul>
          <li style={{display: "inline-block", width: "50%"}}><h4><TickSvg />创投数据库</h4></li>
          <li style={{display: "inline-block", width: "50%"}}><h4><TickSvg />创业与投资人脉</h4></li>
          <li style={{display: "inline-block", width: "50%"}}><h4><TickSvg />烯牛先见科创大模型问答</h4></li>
          <li style={{display: "inline-block", width: "50%"}}><h4><TickSvg />科创情报智能监控</h4></li>
        </ul>
        <div className={styles.mt36}>
          <img src="./static-official/images/downloads.png" alt="App下载" height={150}/>
        </div>
      </div>
    </div>
  </section>
}

function Tool() {
  return <section className={styles.commonSectionA}>
    <div className={styles.detailContainer}>
      <div className={styles.detailBlock}>
        <h3>03 数据插件</h3>
        <ul>
          <li>
            <h4 style={{display: "inline-block"}}><TickSvg />企业数据查询-飞书AI捷径</h4><a target="_blank" rel="noreferrer" href="https://xiniushuju.feishu.cn/base/extension/replit_3e3a26dbf03123e4"><span>立即获取&nbsp;&nbsp;</span><ArrowSvg /></a>
            <desc>提供企业信息查询功能，用户输入公司名称即可快速获取公司全称、简介、代码、团队等多维信息。</desc>
          </li>
          <li>
            <h4 style={{display: "inline-block"}}><TickSvg />烯牛创投数据-飞书版</h4><a target="_blank" rel="noreferrer" href="https://app.feishu.cn/app/cli_a1e3dc12e3b8d00c" ><span>立即获取&nbsp;&nbsp;</span><ArrowSvg /></a>
            <desc>为金融机构提供灵活易用的数据连接器，与飞书多维表格无缝衔接，满足小型投资管理系统与数据库需求。</desc>
          </li>
          <li>
            <h4 style={{display: "inline-block"}}><TickSvg />烯牛营销情报-飞书版</h4><a target="_blank" rel="noreferrer" href="https://app.feishu.cn/app/cli_a3aa98faf962100e" ><span>立即获取&nbsp;&nbsp;</span><ArrowSvg /></a>
            <desc>为企业提供一站式营销管理数据赋能方案，覆盖营销全程三大应用场景。</desc>
          </li>
        </ul>
      </div>
      <img src="./static-official/images/p-3.png" alt="03 数据插件" height={472}/>
    </div>
  </section>
}
